export const MESSAGE_ERRORS = {
  windowLength: "Length must be more 0.",
  nodeNotExist: "Failure: non-existent node in this list. ",
  notArray: "It is not Array",
  windowFound: "Thit window name not found"
};
